import { render, staticRenderFns } from "./GestaoEntregas.vue?vue&type=template&id=6720ecb8&"
import script from "./GestaoEntregas.vue?vue&type=script&lang=js&"
export * from "./GestaoEntregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports